import React from 'react'

const CarePlanPBSAdlIcon = (
  <>
    <g clipPath="url(#clip0_2422_57545)">
      <path
        d="M8.75 10.3125C11.4328 10.3125 13.4375 7.50781 13.4375 5C13.4375 2.41531 11.3347 0.3125 8.75 0.3125C6.16531 0.3125 4.0625 2.41531 4.0625 5C4.0625 7.50781 6.06719 10.3125 8.75 10.3125Z"
        fill="white"
      />
      <path
        d="M11.5625 15.9375C11.5625 14.6053 12.16 13.4144 13.0991 12.6119C11.9194 12.3628 10.4766 12.1875 8.75 12.1875C5.27563 12.1875 2.94781 12.8966 1.60688 13.4916C0.820313 13.84 0.3125 14.6244 0.3125 15.4897V18.75C0.3125 18.9225 0.4525 19.0625 0.625 19.0625H12.8784C12.0672 18.2684 11.5625 17.1625 11.5625 15.9375Z"
        fill="white"
      />
      <path
        d="M15.9375 12.1875C13.8666 12.1875 12.1875 13.8666 12.1875 15.9375C12.1875 18.0084 13.8666 19.6875 15.9375 19.6875C18.0084 19.6875 19.6875 18.0084 19.6875 15.9375C19.6875 13.8666 18.0084 12.1875 15.9375 12.1875ZM18.0334 14.9084L15.5334 17.4084C15.4725 17.4694 15.3925 17.5 15.3125 17.5C15.2325 17.5 15.1525 17.4694 15.0916 17.4084L13.8416 16.1584C13.7194 16.0363 13.7194 15.8387 13.8416 15.7166C13.9637 15.5944 14.1613 15.5944 14.2834 15.7166L15.3125 16.7456L17.5916 14.4666C17.7137 14.3444 17.9113 14.3444 18.0334 14.4666C18.1556 14.5887 18.1556 14.7863 18.0334 14.9084Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2422_57545">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </>
)

export default CarePlanPBSAdlIcon
